import { useMachine } from '@xstate/react'
import { AxiosResponse } from 'axios'
import React from 'react'
import { ColplRouting, useColplRouting } from '../containers/App/RouterApp'
import fetchMachine from '../statecharts/fetchMachine'

interface UseAsyncInterface {
  promiseFn: Function
  onData?: (data: any, params: any) => void
  onError?: ({
    error,
    message,
    params,
  }: {
    error?: AxiosResponse
    message: string
    params: any
  }) => void
}

export default function <P>({
  promiseFn = () => {
    throw new Error('useAsync expects a promiseFn')
  },
  onData,
  onError,
}: UseAsyncInterface) {
  const [current, send] = useMachine(fetchMachine, {
    context: { promiseFn },
  } as any)
  const colplRouting: ColplRouting = useColplRouting()

  const { data, error, params } = current.context
  //@ts-ignore
  if (error && error!.response?.status === 401) {
    // DONE refaktorovat reakci na Unauthorized pro GET /case-report/{id}
    colplRouting.goToCaseRefresh()
    // return nelze v hooku zde -- musi se vracet vzdy stejna struktura !
  }
  React.useEffect(() => {
    if (current.matches('failure') && onError) {
      onError({
        error,
        message:
          // @ts-ignore
          error!.response?.data?.message ?? 'An error happened',
        params,
      })
    }
  }, [current.value])

  React.useEffect(() => {
    if (current.matches('success') && onData) {
      onData(data, params)
    }
  }, [current.value])

  const fetch = React.useCallback(
    (args?: P) => send({ type: 'FETCH', params: args } as any),
    []
  )
  return {
    pending: current.matches('fetching'),
    data,
    error,
    fetch,
  }
}
